import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import { Card, Button } from 'antd'

import TOTAL_ICON from '@/assets/images/icon/upload_total.png'
import SUCCESS_ICON from '@/assets/images/icon/upload_success.png'
import FAIL_ICON from '@/assets/images/icon/upload_fail.png'

import styles from './index.module.scss'

function CustomerUploadReport (props) {
  const location = useLocation()
  const { total = 0, success = 0 } = location.state
  const { history } = props
  const [hoverKey, setHoverKey] = useState('totalHover')

  // 点击返回列表
  const goBack = () => {
    history.push({ pathname: '/customer/customerList' })
  }

  const handleMouseEnter = (key) => {
    setHoverKey(key)
  }

  const handleMouseLeave = (key) => {
    setHoverKey('')
  }

  return (
    <Card bodyStyle={{ padding: '50px 34px', height: '100%' }}>
      <div className={`${styles.header}`}>
        <div className={`${styles.title}`}>全部数据：{total > 0 ? (success / total * 100).toFixed(2) : '0.00'}%</div>
        <Button type='primary' onClick={() => goBack()}>返回列表</Button>
      </div>

        <div className={`${styles.content}`}>
        <div className={`${styles.backgroundBox}`}>
            <div className={`${styles.totalLegendWrap}`}>
              <p className={`${styles.totalLegendLine}`} /><span className={`${styles.totalPoint}`} />
              <p className={`${styles.legendContent} ${styles.totalLegend} ${hoverKey === 'totalHover' ? styles.isHover : ''}`} onMouseEnter={() => handleMouseEnter('totalHover')} onMouseLeave={() => handleMouseLeave('totalHover')}>数据已上传</p>
            </div>
            <div className={`${styles.successLegendWrap}`}>
              <p className={`${styles.successLegendLine}`} /><span className={`${styles.successPoint}`} />
              <p className={`${styles.legendContent} ${styles.successLegend} ${hoverKey === 'successHover' ? styles.isHover : ''}`} onMouseEnter={() => handleMouseEnter('successHover')} onMouseLeave={() => handleMouseLeave('successHover')}>数据完全匹配</p>
            </div>
            <div className={`${styles.failLegendWrap}`}>
              <p className={`${styles.failLegendLine}`} /><span className={`${styles.failPoint}`} />
              <p className={`${styles.legendContent} ${styles.failLegend} ${hoverKey === 'failHover' ? styles.isHover : ''}`} onMouseEnter={() => handleMouseEnter('failHover')} onMouseLeave={() => handleMouseLeave('failHover')}>数据需要修改</p>
            </div>

            <div className={`${styles.totalLabelWrap}`}>
              <p className={`${styles.labelContent} ${styles.totalLegend} ${hoverKey === 'totalHover' ? styles.isHover : ''}`} onMouseEnter={() => handleMouseEnter('totalHover')} onMouseLeave={() => handleMouseLeave('totalHover')}>{total}</p>
              <span className={`${styles.totalPoint}`} /><p className={`${styles.totalLegendLine}`} />
            </div>
            <div className={`${styles.successLabelWrap}`}>
              <p className={`${styles.labelContent} ${styles.successLegend} ${hoverKey === 'successHover' ? styles.isHover : ''}`} onMouseEnter={() => handleMouseEnter('successHover')} onMouseLeave={() => handleMouseLeave('successHover')}>{success}</p>
              <span className={`${styles.successPoint}`} /><p className={`${styles.successLegendLine}`} />
            </div>
            <div className={`${styles.failLabelWrap}`}>
              <p className={`${styles.labelContent} ${styles.failLegend} ${hoverKey === 'failHover' ? styles.isHover : ''}`} onMouseEnter={() => handleMouseEnter('failHover')} onMouseLeave={() => handleMouseLeave('failHover')}>{total - success}</p>
              <span className={`${styles.failPoint}`} /><p className={`${styles.failLegendLine}`} />
            </div>
          </div>
        </div>

        <div className={`${styles.footer}`}>
          <div className={`${styles.flexbox} ${styles.total} ${hoverKey === 'totalHover' ? styles.backgoundHover : ''}`} onMouseEnter={() => handleMouseEnter('totalHover')} onMouseLeave={() => handleMouseLeave('totalHover')}>
            <img className={`${styles.iconBox}`} src={TOTAL_ICON} />
            <div className={`${styles.flexboxBody}`}>
              <div className={`${styles.bodyContent}`}>{total}<span className={`${styles.unit}`}>个</span></div>
              <p className={`${styles.description}`}>数据已上传</p>
            </div>
          </div>

          <div className={`${styles.flexbox} ${styles.success} ${hoverKey === 'successHover' ? styles.backgoundHover : ''}`} onMouseEnter={() => handleMouseEnter('successHover')} onMouseLeave={() => handleMouseLeave('successHover')}>
            <img className={`${styles.iconBox}`} src={SUCCESS_ICON} />
            <div className={`${styles.flexboxBody}`}>
              <div className={`${styles.bodyContent}`}>{success}<span className={`${styles.unit}`}>个</span></div>
              <p className={`${styles.description}`}>数据完全匹配</p>
            </div>
          </div>

          <div className={`${styles.flexbox} ${styles.fail} ${hoverKey === 'failHover' ? styles.backgoundHover : ''}`} onMouseEnter={() => handleMouseEnter('failHover')} onMouseLeave={() => handleMouseLeave('failHover')}>
            <img className={`${styles.iconBox}`} src={FAIL_ICON} />
            <div className={`${styles.flexboxBody}`}>
              <div className={`${styles.bodyContent}`}>{total - success}<span className={`${styles.unit}`}>个</span></div>
              <p className={`${styles.description}`}>数据需要修改</p>
            </div>
          </div>
        </div>
      </Card>
  )
}

CustomerUploadReport.propTypes = {
  history: PropTypes.object
}

export default CustomerUploadReport
